import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@blueprintjs/core';
import { updateNotice } from '../../styled-system/recipes';
import { useAppModel } from '@/models/AppModel';
import { activateOfflineUpdate, dismissOfflineUpdate, useOfflineState } from './offline';
import { UpdateModel } from './UpdateModel';

const styles = updateNotice();

export const UpdateNotice = observer(function UpdateNotice() {
  const app = useAppModel();
  const { update } = useOfflineState();
  const [model] = useState(() => new UpdateModel(app, activateOfflineUpdate));
  useEffect(() => {
    model.setActive(true);
    return () => model.setActive(false);
  }, [model]);
  if (!update || model.dismissed) return null;
  return (
    <aside aria-label="App update" className={styles.root}>
      <div role="status">Update available</div>
      {model.error && <p role="alert">{model.error}</p>}
      <div className={styles.actions}>
        <Button intent="primary" loading={model.busy} onClick={model.update}>
          {app.hasUnsavedProjectChanges ? 'Save and update' : 'Update'}
        </Button>
        <Button disabled={model.busy} minimal onClick={dismissOfflineUpdate}>
          Later
        </Button>
      </div>
    </aside>
  );
});
